import { SECOND_MS } from "~/utils/constants";

export const POI_TIMEOUT_MS = 90 * SECOND_MS; // 90 seconds
